import { Yup } from '@frontman/utils';

export const livingSituationSchema = Yup.object().shape({
  livingSituation: Yup.mixed()
    .oneOf(['homeowner', 'renter'])
    .required('Please select your living situation'),
});
